var map = {
	"./navigation.de-CH.json": 1025,
	"./navigation.de-DE.json": 1026,
	"./navigation.en-CA.json": 1027,
	"./navigation.en-GB.json": 1028,
	"./navigation.en-IN.json": 1029,
	"./navigation.en-ME.json": 1030,
	"./navigation.en-US.json": 1031,
	"./navigation.es-EM.json": 1032,
	"./navigation.es-ES.json": 1033,
	"./navigation.fr-BE.json": 1034,
	"./navigation.fr-CA.json": 1035,
	"./navigation.fr-CH.json": 1036,
	"./navigation.nl-BE.json": 1037,
	"./navigation.nl-NL.json": 1038,
	"./navigation.pl-PL.json": 1039,
	"./navigation.pt-BR.json": 1040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1024;